import React from 'react';

import { Surface } from '@infoods/lifebase-ui';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import { observer } from 'mobx-react';

import classes from './CustomerSuccessWidget.module.scss';
import { StatisticInfoCard } from '../../../../../shared/components/StatisticInfoCard/StatisticInfoCard';
import { WidgetTitle } from '../../../../components/WidgetTitle/WidgetTitle';
import { useScanIqCustomerSuccess } from './hooks/useScanIqCustomerSuccess';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';

const CustomerSuccessWidget = observer(() => {
  const { getEntityId } = loggedInUserDataStore;

  const entityId = getEntityId();
  const { customerSuccess } = useScanIqCustomerSuccess(entityId);

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Customer Success"
        icon={<ThumbUpAltOutlinedIcon fontSize="small" />}
      />
      {customerSuccess && (
        <div className={classes.row}>
          <StatisticInfoCard
            title="Total Number of People Scanned"
            value={customerSuccess.totalNumberOfPeopleScanned}
          />
          <StatisticInfoCard
            title="Total Number of Scans"
            value={customerSuccess.totalNumberOfScans}
          />
        </div>
      )}
    </Surface>
  );
});

export { CustomerSuccessWidget };
